function showCookieSettings() {
  try {
    const btn = document.getElementById('otSDKShowSettings');
    btn.click();
  } catch (error) {
    // Log the error to the console
    console.error('Error opening cookie policy:', error);
  }
}

export default showCookieSettings;



// WEBPACK FOOTER //
// ./src/utils/showCookieSettings.js